import { render } from "./LocaleSwitcher.vue?vue&type=template&id=59db2f9b"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=js"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/vue/vue-3-multi-idioma/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__